
import { useState, useEffect } from 'react';
import { bannerSlides } from '../../../mocks/products';
import { getBanners } from '../../../api/apiServices';

export default function BannerCarousel() {
  const [currentSlide, setCurrentSlide] = useState(0);
  const [banners, setBanners] = useState([]);
  const [loading, setLoading] = useState(false);

  const loadBanners = async () => {
      try {
        setLoading(true);
        const res = await getBanners();
  
        // ensure consistent id usage
        const formatted = (res || []).map((b, index) => ({
          ...b,
          id: b._id,
          order: b.order || index + 1,
        }));
  
        setBanners(formatted);
      } catch (err) {
        console.error("Failed to load banners:", err);
      } finally {
        setLoading(false);
      }
    };
  
    useEffect(() => {
      loadBanners();
    }, []);

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % bannerSlides.length);
    }, 5000);
    return () => clearInterval(timer);
  }, []);

  return (
    <div className="relative w-full h-[150px] md:h-[280px] rounded-2xl overflow-hidden my-8">
      <div 
        className="flex w-full h-full transition-transform duration-500 ease-in-out"
        style={{ transform: `translateX(-${currentSlide * 100}%)` }}
      >
        {banners.map((banner) => (
          <div key={banner.id} className="w-full h-full flex-shrink-0 relative">
            <img
              src={banner.image}
              alt={banner.title}
              className="w-full h-full object-cover"
            />
            <div className="absolute inset-0 bg-gradient-to-r from-[#EF579A]/20 to-transparent"></div>
          </div>
        ))}
      </div>
      <div className="absolute bottom-4 left-1/2 -translate-x-1/2 flex space-x-2 z-10">
        {banners.map((_, index) => (
          <button
            key={index.id}
            onClick={() => setCurrentSlide(index)}
            className={`w-2.5 h-2.5 rounded-full transition-all duration-200 cursor-pointer ${
              currentSlide === index ? 'bg-[#EF579A] w-6' : 'bg-white/70 hover:bg-white'
            }`}
            aria-label={`Go to slide ${index + 1}`}
          ></button>
        ))}
      </div>
    </div>
  );
}
